export const PATH = {
  LOGIN: '/login',
  INTRO: '/intro',
  PROFILE: '/profile',
  DRIVERS: '/drivers',
  LICENSE_PLATES: '/license-plates',
  PAYMENT: '/payment',
  DEBIT_ACCOUNT_TRANSACTIONS: '/payment/debit-account-transactions',
  ADD_CREDIT_CARD: '/payment/credit-card',
  ORDERS: '/orders',
  STATS: '/stats',
  COUPON: '/coupon',
  POINTS: '/points',
  BROWSER_NOT_SUPPORT: '/browser-not-support',
};
